import { render } from "./Shares.vue?vue&type=template&id=3b4ec9de"
import script from "./Shares.vue?vue&type=script&lang=js"
export * from "./Shares.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ahmadsabri-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__